/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommuterPass, getCommuterPassByAPIResponse } from "./commuterPass";
import { getMovementLogByAPIResponse, MovementLog } from "./movementLog";

import { MovementRoute } from "models/movementRoute";
import { TransportationExpense } from "models/transportationExpense";

export interface MonthSummary {
  movementLogApprovalId?: number;
  applicationStatus: string;
  applicationStatusName: string;
  workCount: number;
  totalDistanceKm: number;
  totalFare: number;
  totalTime: number;
  applicantComment?: string;
  approverComment?: string;
  commuterPasses: [];
  commutingExpenses: {
    publicTransportationCount: number;
    publicTransportationList: [];
    bicycleCount: number;
    bicycleList: [];
    myCarCount: number;
    myCarList: [];
    totalFare: number;
  };
  travelExpenses: {
    publicTransportationCount: number;
    publicTransportationList: [];
    totalFare: number;
  };
}

export interface DaySummary {
  date: string;
  workStatus: string;
  applicationStatus: string;
  commutingExpenses: CommutingExpense[];
  transportationExpenses: TransportationExpense[];
}

export interface CommutingExpense {
  id: number;
  at: string;
  account: string;
  totalDistanceKm: number;
  totalFare: number;
  totalTime: number;
  arrivalId: number;
  arrivalCode: string;
  arrivalName: string;
  arrivalTime: Date;
  departureId: number;
  departureCode: string;
  departureName: string;
  departureTime: Date;
  movementRoutes: MovementRoute[];
  modifiedBy: "user" | "system";
}

export const getMonthSummaryByResult = (data: any): MonthSummary => {
  const monthSummary = data.month_summary;

  return {
    movementLogApprovalId: monthSummary.movement_log_approval_id,
    applicationStatus: monthSummary.application_status,
    applicationStatusName: monthSummary.application_status_name,
    workCount: monthSummary.work_count,
    totalDistanceKm: monthSummary.total_distance_km,
    totalFare: monthSummary.total_fare,
    totalTime: monthSummary.total_time,
    applicantComment: monthSummary.applicant_comment,
    approverComment: monthSummary.approver_comment,
    commuterPasses: monthSummary.commuter_passes.reduce(
      (acc: CommuterPass[], commuterPass: any) => [
        ...acc,
        getCommuterPassByAPIResponse(commuterPass),
      ],
      []
    ),
    commutingExpenses: {
      publicTransportationCount:
        monthSummary.commuting_expenses.public_transportation_count,
      publicTransportationList:
        monthSummary.commuting_expenses.public_transportation_list.reduce(
          (acc: MovementLog[], movementLog: any) => [
            ...acc,
            getMovementLogByAPIResponse(movementLog),
          ],
          []
        ),
      bicycleCount: monthSummary.commuting_expenses.bicycle_count,
      bicycleList: monthSummary.commuting_expenses.bicycle_list.reduce(
        (acc: MovementLog[], movementLog: any) => [
          ...acc,
          getMovementLogByAPIResponse(movementLog),
        ],
        []
      ),
      myCarCount: monthSummary.commuting_expenses.my_car_count,
      myCarList: monthSummary.commuting_expenses.my_car_list.reduce(
        (acc: MovementLog[], movementLog: any) => [
          ...acc,
          getMovementLogByAPIResponse(movementLog),
        ],
        []
      ),
      totalFare: monthSummary.commuting_expenses.total_fare,
    },
    travelExpenses: {
      publicTransportationCount:
        monthSummary.travel_expenses.public_transportation_count,
      publicTransportationList:
        monthSummary.travel_expenses.public_transportation_list.reduce(
          (acc: MovementLog[], movementLog: any) => [
            ...acc,
            getMovementLogByAPIResponse(movementLog),
          ],
          []
        ),
      totalFare: monthSummary.travel_expenses.total_fare,
    },
  };
};

export const getDaySummariesByResult = (data: any) => {
  const daySummaries = data.day_summary;
  return daySummaries.reduce(
    (acc: DaySummary[], daySummary: any) => [
      ...acc,
      {
        date: daySummary.date,
        workStatus: daySummary.workStatus,
        applicationStatus: daySummary.applicationStatus,
        commutingExpenses: daySummary.commutingExpense.reduce(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (acc2: CommutingExpense[], commutingExpense: any) => [
            ...acc2,
            {
              account: commutingExpense.account,
              arrivalId: commutingExpense.arrival_id,
              arrivalCode: commutingExpense.arrival_code,
              arrivalName: commutingExpense.arrival_name,
              arrivalTime: commutingExpense.arrival_time,
              at: commutingExpense.at,
              departureId: commutingExpense.departure_id,
              departureCode: commutingExpense.departure_code,
              departureName: commutingExpense.departure_name,
              departureTime: commutingExpense.departure_time,
              id: commutingExpense.id,
              totalDistanceKm: commutingExpense.total_distance_km,
              totalFare: commutingExpense.total_fare,
              totalTime: commutingExpense.total_time,
              movementRoutes: [],
              modifiedBy: commutingExpense.modified_by,
            },
          ],
          []
        ),
        transportationExpenses: daySummary.transportationExpense.reduce(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (acc2: TransportationExpense[], transportationExpense: any) => [
            ...acc2,
            {
              account: transportationExpense.account,
              arrivalId: transportationExpense.arrival_id,
              arrivalCode: transportationExpense.arrival_code,
              arrivalName: transportationExpense.arrival_name,
              arrivalTime: transportationExpense.arrival_time,
              at: transportationExpense.at,
              departureId: transportationExpense.departure_id,
              departureCode: transportationExpense.departure_code,
              departureName: transportationExpense.departure_name,
              departureTime: transportationExpense.departure_time,
              id: transportationExpense.id,
              totalDistanceKm: transportationExpense.total_distance_km,
              totalFare: transportationExpense.total_fare,
              totalTime: transportationExpense.total_time,
              movementRoutes: [],
              modifiedBy: transportationExpense.modified_by,
            },
          ],
          []
        ),
      },
    ],
    []
  );
};
/* eslint-enable */
